import React from 'react';
import PropTypes from 'prop-types';
import {
  CarouselProvider, Slider, Slide, ButtonBack, ButtonNext,
} from 'pure-react-carousel';
import { Icon } from '@resy/ui-kitchen';
import orderBy from 'lodash/orderBy';
import Logger from '../../../../../../ui-kitchen/src/utils/logger';
import Chevron from '../../../../images/icons/chevron-left.svg';
import AmexCarouselEditorialCard from './AmexCarouselEditorialCard';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import 'pure-react-carousel/dist/react-carousel.es.css';
import './AmexCarouselEditorial.scss';

/**
 * This is used in /amexgold for displaying Editorial Component
 */
class AmexCarouselEditorial extends React.Component {
  state = {
    blogDataResponseList: [],
  }

  async componentDidMount() {
    const { blogDataArray } = this.props;
    this.getEditorialData(blogDataArray);
  }

  getEditorialData = (blogDataArray) => {
    const blogDataResponseList = [];

    for (let index = 0; index < blogDataArray.length; index += 1) {
      const {
        _links, link, title, id, position,
      } = blogDataArray[index];
      const imageDownloadUrl = _links['wp:featuredmedia'][0].href;
      const cityCode = blogDataArray[index]['resy:market'].primary_market;
      let authorNames = '';
      try {
        let authArray = blogDataArray[index]['resy:authors'];
        authArray = authArray.map((item, count) => {
          authorNames = 'By ';
          if (count !== authArray.length - 1) {
            return `${item.name} \u00B7 `;
          }
          return item.name;
        });
        for (let iCount = 0; iCount < authArray.length; iCount += 1) {
          authorNames = `${authorNames}${authArray[iCount]}`;
        }
      } catch (err) {
        Logger.error('author exception');
      }

      let imageLinkValue = '';
      let cityNameValue = '';
      let cityName;

      const imageLink = this.fetchImage(imageDownloadUrl);

      if (cityCode || cityCode !== '') {
        cityName = this.fetchCity(cityCode);
      }

      let obj = {
        link,
        title: title.rendered,
        id,
        position,
        author: authorNames,
      };

      imageLink.then((b) => {
        imageLinkValue = b;
        obj = {
          ...obj,
          imageLink: imageLinkValue,
        };
        if (cityName) {
          cityName.then((c) => {
            cityNameValue = c || '';
            obj = {
              ...obj,
              cityName: cityNameValue,
            };
            this.updateStateArray(blogDataResponseList, obj, blogDataArray);
            return null;
          });
        } else {
          this.updateStateArray(blogDataResponseList, obj, blogDataArray);
        }
      });
    }
  }

  validateEditorialsContent = (blogDataResponseList) => {
    const requiredKeys = ['title', 'imageLink'];
    return blogDataResponseList
      .filter((item) => requiredKeys.every((i) => Object.prototype.hasOwnProperty.call(item, i) && item[i]));
  }

  updateStateArray = (blogDataResponseList, obj, blogDataArray) => {
    blogDataResponseList.push(obj);
    const validatedBlogList = this.validateEditorialsContent(blogDataResponseList);
    if (blogDataResponseList.length === blogDataArray.length) {
      const blogDataArrayReOrdered = orderBy(validatedBlogList, ['position'], ['asc']);
      this.setState({ blogDataResponseList: blogDataArrayReOrdered });
    }
  }

  fetchImage = async (imageDownloadUrl) => {
    let blogResponseImage = '';

    try {
      const blogImageData = await fetch(imageDownloadUrl, {
        method: 'GET',
      });
      const blogResponseImageData = await blogImageData.json();
      blogResponseImage = blogResponseImageData.media_details.sizes.medium.source_url;
    } catch {
      return blogResponseImage;
    }

    return blogResponseImage;
  }

  fetchCity = async (cityCode) => {
    const { gdaEditorialApi } = this.props;
    const cityNameUrl = `${gdaEditorialApi}city_landing/?filter[meta_key]=code&filter[meta_value]=${cityCode}`;
    let cityName = '';

    try {
      const responseCityData = await fetch(cityNameUrl, {
        method: 'GET',
      });
      const blogResponseCityData = await responseCityData.json();
      cityName = blogResponseCityData[0].title.rendered;
    } catch {
      return cityName;
    }

    return cityName;
  }

  renderButtons = () => (
    <>
      <ButtonBack aria-label="Previous slide" aria-controls="editorialCarousel">
        <span className="AmexCarouselEditorial__carousel-button-container" aria-hidden="true">
          <Icon
            name="Chevron"
            component={Chevron}
          />
        </span>
      </ButtonBack>
      <ButtonNext aria-label="Next slide" aria-controls="editorialCarousel">
        <span className="AmexCarouselEditorial__carousel-button-container" aria-hidden="true">
          <Icon
            name="Chevron"
            component={Chevron}
          />
        </span>
      </ButtonNext>
    </>
  );

  renderMobileCards = (editorialCardProps) => {
    const { blogDataResponseList } = this.state;
    const cards = [];
    const blogLength = blogDataResponseList.length;
    for (let i = 0; i < blogLength; i += 1) {
      cards.push((
        <AmexCarouselEditorialCard
          key={blogDataResponseList[i].id}
          blogData={blogDataResponseList[i]}
          {...editorialCardProps}
        />
      ));
    }
    return cards;
  }

  render() {
    const { blogDataResponseList } = this.state;
    const {
      editorialsConfig: {
        title,
        copy = '',
        id: sectionId,
        sr_info: srInfo,
        sr_controls_aria: srControlsAria,
        show_city: showCity = true,
      },
      Analytics,
      matchMedia,
      taggingConfig,
    } = this.props;

    const sanitizedTitle = sanitizeString(title);
    const sanitizedCopy = sanitizeString(copy);

    if (blogDataResponseList.length === 0 || !blogDataResponseList) {
      return null;
    }

    const editorialCardProps = {
      Analytics,
      matchMedia,
      showCity,
      taggingConfig,
    };

    const blogLen = blogDataResponseList.length;
    const visibleSlides = 4;
    return (
      <section className="AmexCarouselEditorial">
        <div className="container">
          {title && (
            <h2
              id={sectionId}
              className="AmexCarouselEditorial__header__title"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedTitle,
              }}
            />
          )}
          {copy && (
            <p
              className="AmexCarouselEditorial__header__copy"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedCopy,
              }}
            />
          )}
          {!matchMedia.lg ? (
            <div className="AmexCarouselEditorial__mobile">
              <ul className="AmexCarouselEditorial__mobile-grid">
                {blogDataResponseList && this.renderMobileCards(editorialCardProps)}
              </ul>
            </div>
          ) : (
            <div className="AmexCarouselEditorial__carousel">
              <CarouselProvider
                visibleSlides={visibleSlides}
                totalSlides={blogLen}
                step={4}
                dragEnabled={false}
                naturalSlideWidth={400}
                naturalSlideHeight={650}
                isIntrinsicHeight="true"
                id="editorialCarousel"
                aria-labelledby={sectionId}
                aria-roledescription="carousel"
              >
                <div className="AmexCarouselEditorial__carousel__container">
                  {blogDataResponseList.length > 4 && (
                    <div
                      role="group"
                      aria-label={srControlsAria}
                      className="AmexCarouselEditorial__carousel__controls"
                    >
                      <p className="sr-only">
                        {srInfo}
                      </p>
                      {this.renderButtons()}
                    </div>
                  )}
                  <Slider tabIndex={-1}>
                    {blogDataResponseList && blogDataResponseList.map((item, index) => (
                      <Slide
                        index={index}
                        key={item.id}
                        aria-label={item.title}
                        aria-roledescription="slide"
                      >
                        <AmexCarouselEditorialCard
                          key={item.id}
                          blogData={item}
                          {...editorialCardProps}
                        />
                      </Slide>
                    ))}
                  </Slider>
                </div>
              </CarouselProvider>
            </div>
          )}
        </div>
      </section>
    );
  }
}

AmexCarouselEditorial.defaultProps = {
  blogDataArray: [],
};

AmexCarouselEditorial.propTypes = {
  blogDataArray: PropTypes.arrayOf(PropTypes.shape({})),
  gdaEditorialApi: PropTypes.string.isRequired,
  editorialsConfig: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    sr_info: PropTypes.string.isRequired,
    sr_controls_aria: PropTypes.string.isRequired,
    show_city: PropTypes.bool.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  taggingConfig: PropTypes.shape({
    utm: PropTypes.string.isRequired,
  }).isRequired,
};

export default AmexCarouselEditorial;
